import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, values } from 'lodash';
import { MAX_APPLICABLE_INTAKE_FILTERS } from '../policy';

import { SFAccordion } from 'SF/SFAccordion';
import OneToFiveFilterPanel from './OneToFiveFilterPanel';
import CheckboxFilterPanel from './CheckboxFilterPanel';
import YesNoFilterPanel from './YesNoFilterPanel';
import DecimalFilterPanel from './DecimalFilterPanel';
import DateRangeFilterPanel from './DateRangeFilterPanel';
import ShortTextFilterPanel from './ShortTextFilterPanel';
import MonthRangeFilterPanel from './MonthRangeFilterPanel';
import IntakeQuestionFilterToolTip from '../IntakeQuestionFilterToolTip';
import TrackVisualFocus from '../../SF/TrackVisualFocus';

export default class IntakeQuestionPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = { visualFocusActive: false };
  }

  questionComponents = {
    FULL_DATE: DateRangeFilterPanel,
    DECIMAL: DecimalFilterPanel,
    YES_NO: YesNoFilterPanel,
    RADIO_STRING: CheckboxFilterPanel,
    MULTI_STRING: CheckboxFilterPanel,
    ONE_TO_FIVE: OneToFiveFilterPanel,
    MONTH_YEAR: MonthRangeFilterPanel,
    TEXT: ShortTextFilterPanel
  };

  getQuestionComponent(questionType) {
    const QuestionComponent = this.questionComponents[questionType];
    if (!QuestionComponent) {
      console.log("no question component for ", questionType);
      return null;
    }
    return QuestionComponent;
  }

  filterTitleClass = () => {
    if (this.isValueEmpty(this.props.value)) {
      return 'sf-intake-filter-unselected';
    } else {
      return 'sf-intake-filter-selected';
    }
  };

  setVisualFocusActive(visualFocusActive) {
    this.setState({ visualFocusActive });
  }

  isValueEmpty (val) {
    return isEmpty(val) || isEmpty(values(val));
  }

  getFilterSelectionLimitToolTip () {
    const atSelectionLimit = this.props.selectionCount >= MAX_APPLICABLE_INTAKE_FILTERS;

    if (!atSelectionLimit || !this.state.visualFocusActive || !this.isValueEmpty(this.props.value)) {
      return null;
    }

    return <IntakeQuestionFilterToolTip />;
  }

  render() {
    const QuestionComponent = this.getQuestionComponent(this.props.question.type);
    if (!QuestionComponent) {
      return null;
    }

    return (
      <SFAccordion title={this.props.question.text} titleClass={this.filterTitleClass()}>
        {this.getFilterSelectionLimitToolTip()}
        <TrackVisualFocus onEnter={() => this.setVisualFocusActive(true)}
                          onExit={() => this.setVisualFocusActive(false)}>
          <QuestionComponent {...this.props}  />
        </TrackVisualFocus>
      </SFAccordion>
    );
  }
}

IntakeQuestionPanel.propTypes = {
  selectionCount: PropTypes.number.isRequired,
  question: PropTypes.shape({
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ])
}
